const mr = {
    title: 'SketchScope: Motion Recognition',
    about: '아래 영상과 같이 각 모드 별로 지정된 손동작을 인식하여 Create Mode, Modify Mode, 그리고 Rotate Mode를 사용할 수 있습니다.\n' +
        '이를 통해서 다양한 설치 환경에서도 SketchScope가 작동할 수 있게 됩니다.\n',
    paperlink: 'https://www.dbpia.co.kr/journal/articleDetail?nodeId=NODE10441923',
    interface: '미정',
    updates: 'Leap Motion에서 Motion Recognition이 어떻게 이뤄졌는지 확인할 수 있습니다. \n' +
        '자세한 사항은 아래 데모 영상을 참고해 주세요.\n',
    demo: "@/assets/sketchscope.png"
}

export {mr}